import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const LockLockedIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.1336 15H2.86693C2.35173 15 1.93359 14.5818 1.93359 14.0666V7.53331C1.93359 7.01811 2.35173 6.59998 2.86693 6.59998H13.1336C13.6488 6.59998 14.0669 7.01811 14.0669 7.53331V14.0666C14.0669 14.5818 13.6488 15 13.1336 15Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      d="M4.7334 6.6V4.26667C4.7334 2.46253 6.19593 1 8.00007 1C9.8042 1 11.2667 2.46253 11.2667 4.26667V6.6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </svg>
);
